// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","pressRow":"_3Coi0cw4vYFjAUKwHfBxC7","pressColumn":"s6II7LhwJ4CFEtekjvCac","pressDescription":"cXtI5fbMlFHiy9Wzox7Fp","insteadButton":"pTOvVL8YIefNXyCAcfIfD"};